module.exports = __webpack_public_path__ + "img/slogan.fc84eef9.png";